import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end',
  },
  container: {
    backgroundColor: 'white',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '80%',
    paddingBottom: 20,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: Colors.GrayPallete.lightgrayThree + '30',
  },
  title: {
    fontSize: 18,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
  },
  closeButton: {
    fontSize: 24,
    color: Colors.GrayPallete.lightgrayThree,
  },
  section: {
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  sectionTitle: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
    marginBottom: 12,
  },
  option: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    marginBottom: 8,
    backgroundColor: Colors.GrayPallete.lightgrayThree + '10',
  },
  optionSelected: {
    backgroundColor: Colors.RedPallete.red + '15',
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
  },
  optionText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  optionTextSelected: {
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.RedPallete.red,
  },
  radioSelected: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: Colors.RedPallete.red,
  },
  checkSelected: {
    width: 20,
    height: 20,
    borderRadius: 4,
    backgroundColor: Colors.RedPallete.red,
  },
  footer: {
    flexDirection: 'row',
    paddingHorizontal: 20,
    paddingTop: 16,
    gap: 12,
  },
  buttonClean: {
    flex: 1,
    paddingVertical: 14,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
    alignItems: 'center',
  },
  buttonCleanText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.RedPallete.red,
  },
  buttonApply: {
    flex: 1,
    paddingVertical: 14,
    borderRadius: 8,
    backgroundColor: Colors.RedPallete.red,
    alignItems: 'center',
  },
  buttonApplyText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'white',
  },
});
